import { httpClientSessionManager } from '../infra/http-client-session-manager'
import { type GetPaymentProfilesParams, type PaymentProfilesResponse } from '../types'

export const getPaymentProfiles = ({ stoneAccountId }: GetPaymentProfilesParams) =>
  httpClientSessionManager<PaymentProfilesResponse>({
    url: `/api/v1/session-manager/stone-accounts/${stoneAccountId}/payment-profiles`,
    method: 'GET'
  })
